import styled from 'styled-components';
import { FontFamily } from '@zocdoc/components/src/typography';
import { Link } from '@zocdoc/components/src/link';

const FilterLink = styled(Link)`
    font-family: ${FontFamily.SharpSansSemibold};
    font-size: 14px;
    margin-bottom: 8px;
`;

export default FilterLink;
